module.exports = __webpack_public_path__ + "img/team-shield.7a6517f0.svg";